import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { RefreshCw, Settings } from 'lucide-react';

const LoopNode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-pink-500 text-white border-2 ${
        selected ? 'border-pink-300' : 'border-pink-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <RefreshCw className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-pink-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.type && (
          <div className="text-xs mt-1 opacity-90">
            {data.config.type}: {data.config.iterations || data.config.condition}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#ec4899',
            border: '2px solid #db2777',
          }}
        />
        
        {/* Loop body output */}
        <Handle
          type="source"
          position={Position.Right}
          id="loop"
          style={{
            background: '#22c55e',
            border: '2px solid #16a34a',
            top: '50%'
          }}
        />
        
        {/* Exit output */}
        <Handle
          type="source"
          position={Position.Bottom}
          id="exit"
          style={{
            background: '#ec4899',
            border: '2px solid #db2777',
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure Loop Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Loop Type</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>For Each Item</option>
                  <option>Fixed Count</option>
                  <option>While Condition</option>
                  <option>Until Condition</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Data Source/Count</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="{{array_variable}} or 10"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Loop Variable</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="item (variable for current iteration)"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Condition (for while/until)</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="{{counter}} < 10"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Max Iterations</label>
                <input 
                  type="number"
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="100"
                />
              </div>
              <div className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" />
                <label className="text-sm text-gray-700">Parallel execution</label>
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-pink-600 text-white rounded-lg hover:bg-pink-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoopNode;